// extracted by mini-css-extract-plugin
export default {"container":"DashboardContainer_container__SOWmu","task":"DashboardContainer_task__sGHyQ","wrapper":"DashboardContainer_wrapper__kKt+G"};